import { z } from 'zod';

export const ActivityTotalsSchema = z
  .object({
    stored: z.number().nonnegative().optional(),
    total: z.number().nonnegative().optional(),
    failed: z.number().nonnegative().optional(),
    dataType: z.string().optional(),
    resolvedUsers: z.number().nonnegative().optional(),
  })
  .catchall(z.unknown());

export const ActivityMetadataSchema = z.record(z.string(), z.unknown());

export const ActivitySchema = z.object({
  id: z.string(),
  userId: z.string(),
  userName: z.string().nullable(),
  source: z.string(),
  type: z.string(),
  status: z.string(),
  correlationId: z.string().nullable(),
  jobId: z.string().nullable(),
  totals: ActivityTotalsSchema,
  metadata: ActivityMetadataSchema,
  error: z.string().nullable(),
  createdAt: z.date(),
  finishedAt: z.date().nullable(),
});

export const ActivityCreateBodySchema = z.object({
  type: z.string(),
  data: z.record(z.string(), z.unknown()).optional(),
});
export type ActivityCreateBody = z.infer<typeof ActivityCreateBodySchema>;

export const ActivityCreateResponseSchema = z.object({
  id: z.string(),
  type: z.string(),
  createdAt: z.date(),
});
export type ActivityCreateResponse = z.infer<typeof ActivityCreateResponseSchema>;

export const ActivityListQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).optional(),
  offset: z.coerce.number().int().min(0).optional(),
  type: z.string().optional(),
});
export type ActivityListQuery = z.infer<typeof ActivityListQuerySchema>;

export const ActivityListResponseSchema = z.object({
  activities: z.array(ActivitySchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export type Activity = z.infer<typeof ActivitySchema>;
export type ActivityTotals = z.infer<typeof ActivityTotalsSchema>;
export type ActivityMetadata = z.infer<typeof ActivityMetadataSchema>;
export type ActivityListResponse = z.infer<typeof ActivityListResponseSchema>;

export const ActivityEventSchema = z.object({
  id: z.string(),
  activityId: z.string(),
  timestamp: z.date(),
  level: z.string(),
  message: z.string(),
  data: z.unknown().nullable(),
});

export type ActivityEvent = z.infer<typeof ActivityEventSchema>;
